import React from "react";
import { Button } from "react-bootstrap";
import MultiSelectWithCheckboxes from "./MultiSelect";

const FilterControls = ({
  filters,
  filterData,
  setFilterData,
  hasFilters,
  filtersApplied,
  showAppliedEffect,
  handleApplyFilter,
  handleClearFilter,
}) => {
  return (
    <>
      {filters.map((filter) => (
        <div
          key={filter.id}
          className="p-0 mx-2"
          style={{
            maxWidth: filter.maxWidth || "250px",
            width: filter.width || "150px",
          }}
        >
          <MultiSelectWithCheckboxes
            id={filter.id}
            className={filter.className}
            aria-label={filter.ariaLabel}
            value={filterData?.[filter.id] || filter.defaultValue}
            optionsList={filter.optionsList}
            placeholder={filter.placeholder}
            formData={filterData}
            setFormData={setFilterData}
            isMulti={filter.isMulti ?? true}
            showSelectAll={filter.showSelectAll ?? false}
            isFilter={true}
            {...filter.props}
          />
        </div>
      ))}

      {/* {hasFilters && (
        <div className="p-0" style={{ maxWidth: "300px" }}>
          <div className="p-0 mx-2 d-flex align-items-center gap-2">
            <Button
              onClick={handleApplyFilter}
              className={`filter-btn ${showAppliedEffect ? "applied" : ""}`}
            >
              <svg
                viewBox="0 0 64 64"
                xmlns="http://www.w3.org/2000/svg"
                strokeWidth="3"
                stroke="#000000"
                fill="none"
              >
                <line x1="50.69" y1="32" x2="56.32" y2="32" />
                <line x1="7.68" y1="32" x2="38.69" y2="32" />
                <line x1="26.54" y1="15.97" x2="56.32" y2="15.97" />
                <line x1="7.68" y1="15.97" x2="14.56" y2="15.97" />
                <line x1="35" y1="48.03" x2="56.32" y2="48.03" />
                <line x1="7.68" y1="48.03" x2="23" y2="48.03" />
                <circle cx="20.55" cy="15.66" r="6" />
                <circle cx="44.69" cy="32" r="6" />
                <circle cx="29" cy="48.03" r="6" />
              </svg>
              Apply Filters
            </Button>

            {filtersApplied && (
              <Button
                variant="outline-secondary"
                onClick={handleClearFilter}
                style={{
                  width: "38px",
                  height: "38px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: "#fecaca",
                  color: "#dc2626",
                  fontSize: "20px",
                  fontWeight: "600",
                  borderRadius: "6px",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fee2e2";
                  e.currentTarget.style.borderColor = "#fca5a5";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#fef2f2";
                  e.currentTarget.style.borderColor = "#fecaca";
                }}
              >
                &times;
              </Button>
            )}
          </div>
        </div>
      )} */}
    </>
  );
};

export default FilterControls;
